import React from 'react';
import ReactDOM from 'react-dom/client';
import BlueYardScene from './components/blueyard-scene.js';
import '../foundation.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BlueYardScene />
  </React.StrictMode>,
);
